/**
 * Runtime polyfills for APIs that are missing on engines still inside our
 * support floor (the `browserslist` field in package.json). Imported first from
 * entry-client.ts so they land before anything renders.
 *
 * `build.target` only downlevels *syntax* — runtime methods have to be filled
 * in here, and `npm run check:browser-support` flags any new ones a dependency
 * drags in.
 */

/**
 * Array/String.prototype.at — Chrome 92, Safari 15.4. iOS 15.0–15.3 and Android
 * WebViews older than 92 sit inside the floor but predate it, and vuestic-ui
 * calls it while setting up every single component.
 */
function at(this: { readonly length: number, readonly [index: number]: unknown }, index: number) {
  const relative = Math.trunc(index) || 0
  const absolute = relative < 0 ? this.length + relative : relative

  return absolute < 0 || absolute >= this.length ? undefined : this[absolute]
}

for (const prototype of [Array.prototype, String.prototype] as object[]) {
  if (!('at' in prototype)) {
    Object.defineProperty(prototype, 'at', { value: at, writable: true, configurable: true })
  }
}
